import {
  BorderGreyBox,
  CardSpg,
  CreatedDateFilter,
  EnabledFilter,
  handleSubmitValidationFail,
  isNotEmpty,
  NameEnFilter,
  NameFilter,
  useReactHookForm,
} from "@duosoftbg/nacid-components";
import { Box, CardContent, Grid } from "@mui/material";
import { useTranslation } from "react-i18next";
import { FormProvider } from "react-hook-form";
import React, { useEffect, useMemo } from "react";
import { useStore } from "react-redux";
import { SEARCH_FILTERS_GROUP } from "../../../../../config/search/filters/groupsConfig";
import { GlobalFilterDetails } from "../../../../../types/globalMessageTypes";
import { globalMessageFilterInitialValues } from "../../../../../init/globalMessageFilterInitialValues";
import { createGlobalMessageFilterValidationSchema } from "../../../../../yup/schema/globalMessage/globalMessageFilterValidationSchema";
import useSearchTableControl from "../../../../../hooks/portal/search/useSearchTableControl";
import { selectGlobalMessages } from "../../../../../axios/api/services";
import SearchFilters from "../../../../components/common/search/filters/SearchFilters";
import GlobalMessageList from "./GlobalMessageList";
import TextFilter from "../../../../components/common/search/filters/definition/TextFilter";
import TextEnFilter from "../../../../components/common/search/filters/definition/TextEnFilter";
import LastUpdateDateFilter from "../../../../components/common/search/filters/definition/LastUpdateDateFilter";
import GlobalMessageTypesFilter from "../../../../components/common/search/filters/definition/status/GlobalMessageTypesFilter";
import { RootState } from "../../../../../store/redux/store";

const GlobalMessageFilters = () => {
  return (
    <Grid container spacing={5} px={2} py={6}>
      <NameFilter />
      <NameEnFilter />
      <TextFilter />
      <TextEnFilter />
      <CreatedDateFilter />
      <LastUpdateDateFilter />
      <GlobalMessageTypesFilter />
      <EnabledFilter />
    </Grid>
  );
};

const GlobalMessage = () => {
  const { t } = useTranslation();
  const store = useStore();
  const group = SEARCH_FILTERS_GROUP.GLOBAL_MESSAGE_MANAGEMENT;

  const { methods } = useReactHookForm<GlobalFilterDetails>({
    defaultValues: globalMessageFilterInitialValues,
    validationSchema: createGlobalMessageFilterValidationSchema,
  });

  useEffect(() => {
    const filtersData = (store.getState() as RootState).SearchData.portalSearchTable[group].filtersData;
    if (isNotEmpty(filtersData)) {
      methods.reset(filtersData);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const control = useSearchTableControl({
    group,
    methods,
    initialValues: globalMessageFilterInitialValues,
    filterData: selectGlobalMessages,
    callAfterResetFilters: true,
  });

  return (
    <FormProvider {...methods}>
      <form
        onSubmit={methods.handleSubmit(
          () => control.handleSubmitFilters(),
          () => handleSubmitValidationFail(methods.formState, t, undefined),
        )}
      >
        <CardSpg my={4} style={{ overflow: "visible" }}>
          <CardContent style={{ position: "relative" }}>
            <Box>
              <BorderGreyBox>
                <SearchFilters
                  isSubmitBtnDisabled={control.isSubmitBtnDisabled}
                  isResetBtnDisabled={control.isResetBtnDisabled}
                  handleResetFilters={control.handleResetFilters}
                >
                  {/*<GlobalMessageMemoizedFilters />*/}
                  {useMemo(
                    () => (
                      <GlobalMessageFilters />
                    ),
                    [],
                  )}
                </SearchFilters>
              </BorderGreyBox>
              {control.showList && (
                <GlobalMessageList
                  records={control.records}
                  total={control.total}
                  isLoading={control.isLoading}
                  onPageOrOrderChange={control.handlePageOrOrderChange}
                  blockTable={control.blockTable}
                  group={group}
                  fetch={control.fetch}
                />
              )}
            </Box>
          </CardContent>
        </CardSpg>
      </form>
    </FormProvider>
  );
};

export default GlobalMessage;
